import { render } from "./SubInsuredConfirm.vue?vue&type=template&id=4a3598ac"
import script from "./SubInsuredConfirm.vue?vue&type=script&lang=ts"
export * from "./SubInsuredConfirm.vue?vue&type=script&lang=ts"
script.render = render

export default script